/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { isObject } from "utils/lodashUtils";
// list of components listening to keyboard event
let subscribers = [];

export const subscribe = callback => subscribers.push(callback);

export const unsubscribe = callback => {
  const index = subscribers.indexOf(callback);
  if (index !== -1) {
    subscribers.splice(index, 1);
    return true;
  }
  return false;
};

export const keyboardHandler = event => {
  if (!event) {
    return;
  }
  // below change of event.target.id === "inputGsv" should be removed later
  if (
    !(event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) ||
    event.target.id === "inputGsv" ||
    event.target.name === "inline-organize-checkbox"
  ) {
    for (let i = 0; i < subscribers.length; i++) {
      let result,
        shouldPreventDefault = false,
        handled = false;
      result = subscribers[i](event);
      if (isObject(result)) {
        shouldPreventDefault = result.shouldPreventDefault || shouldPreventDefault;
        handled = result.handled || handled;
      } else {
        handled = shouldPreventDefault = result;
      }

      if (handled) {
        if (shouldPreventDefault) {
          event.preventDefault();
        }
        break;
      }
    }
  }
};

export const resetKeyboard = () => {
  subscribers = [];
};
